module.exports = __webpack_public_path__ + "a8ed5244d61deb197fad851e52e6f10b.svg";